import React from "react";
import { humanize } from "../../../common/utils";
import { StudentStatusIcon } from "../../../School/components/StudentProfiles";

const ComplianceStatusComponent = ({ props, immunizationStatusKey, immunizationUrlKey }) => {
  const immunizationStatus = props[immunizationStatusKey];
  const immunizationUrl = props[immunizationUrlKey];
  if (!immunizationStatus) return <span></span>;
  return (
    <a
      className="link-unstyled pointer"
      href={immunizationUrl}
    >
      <span className="fabrx-chip-sm">
        <StudentStatusIcon status={immunizationStatus} />
        {humanize(immunizationStatus)}
      </span>
    </a>
  );
};

export default ComplianceStatusComponent;
